import KunLoading2 from './src/index'

KunLoading2.install = function (Vue){
	Vue.component(KunLoading2.name, KunLoading2);
}

export default KunLoading2;
